import React from "react";

export default function FrontHighlightBlock(props) {
  return (
    <div className="highlightBlock">
      <p>{props.text}</p>
    </div>
  );
}
